import WithAuth from "../../hoc/withAuth";
import { Container } from "./styles";
import { InvoiceTable } from "./_InvoiceTable";

const Invoices = () => {


    return (
        <>
            <Container>
                <InvoiceTable />
            </Container>
        </>
    )
}

export default WithAuth(Invoices);